module.exports = __webpack_public_path__ + "static/media/icon-more-med.67ac27c4.svg";